import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
import '@/assets/css/index.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import "@/utils/rem"
import "@/utils/init"

import MyModal from "@/components/MyModal/index.vue"
import modal from "@/utils/modal"
import myPagination from "@/components/Pagination/index.vue";

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.component('MyModal', MyModal)
Vue.component('myPagination', myPagination)


Vue.prototype.$modal = modal

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
